module.exports = __webpack_public_path__ + "static/media/case2.31ad873f.jpg";